import { createSelector } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { settings } from '../../settings';
const areaSlice = (state) => state[`${settings.uid}/area`];
export const selectArea = createSelector(areaSlice, (area) => area.area);
export const selectAreaBoundaries = createSelector(areaSlice, (area) => area.boundaries);
export const selectAreaTeams = createSelector(areaSlice, (area) => area.teams);
// TODO: To think about more suitable name for this selector.
//       Maybe call it `selectIsAreaTeamZipsProcessing` and return only `isLoading`?
export const selectAreaTeamZips = createSelector(areaSlice, (area) => area.teamZips);
